import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { Menu, MenuItem } from '@material-ui/core';

import { ComposedActions } from '../../../helpers/actions';
import { HermesysColors } from '../Colors';

const MenuBar = styled.div`
  display: flex;
  background: black;
  padding-left: 10px;
  color: white;
  > div:last-child {
    margin-left: auto;
  }
`;

const MenuItems = styled.div`
  margin: 0px 10px;
  cursor: pointer;
  :hover {
    color: ${HermesysColors.main.highlightText};
  }
`;

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    background-color: black;
    color: white;
  }
`;

const StyledMenuListItem = styled(MenuItem)``;

export const menuItems = [
  {
    label: 'View',
    id: 'view',
    children: [
      { label: 'Plans', id: 'view_plans' },
      { label: 'Supervision', id: 'view_supervision' },
      { label: 'History Coms', id: 'view_history_coms' },
    ],
  },
  {
    label: 'Plans',
    id: 'plans',
    children: [
      { label: 'Tactical Lines', id: 'tactical_lines' },
      { label: 'Profiles', id: 'profile_plan' },
      { label: 'Conferences', id: 'conference_plan' },
      { label: 'Grp Call', id: 'grp_call_plan' },
    ],
  },
  {
    label: 'Remote Control',
    id: 'remote_control',
    children: [
      { label: 'Radios/Modems', id: 'radio_modems' },
      { label: 'Antenna Distributor (MCU)', id: 'antenna_distributor' },
      { label: 'Recorder', id: 'recorder' },
    ],
  },
  { label: 'RSlience', id: 'rslience' },
  { label: 'Readiness', id: 'readiness' },
  { label: 'Alarms', id: 'alarms' },
  {
    label: 'Operator',
    id: 'operator',
    children: [
      { label: 'Log Out', id: 'logout' },
      { label: 'Management', id: 'management' },
      { label: 'Master', id: 'master' },
      { label: 'Shared', id: 'shared' },
    ],
  },
  {
    label: 'System',
    id: 'system',
    children: [
      { label: 'About', id: 'about' },
      { label: 'Config', id: 'config' },
      { label: 'Day/Night', id: 'day_night' },
      { label: 'DDBB', id: 'ddbb' },
      { label: 'Power ON/OFF', id: 'power_on_off' },
      { label: 'Reports', id: 'reports' },
      { label: 'VNC Record', id: 'vnc_record' },
    ],
  },
];

export const TopMenuBar = (props) => {
  const [activeMenu, setActiveMenu] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();

  const handleClick = (index, menuItem, event) => {
    setActiveMenu(index);
    setAnchorEl(event.currentTarget);
    if (!menuItem.children) {
      onMenuItemClick(menuItem);
    }
  };

  const handleClose = () => {
    setActiveMenu(null);
  };

  const onMenuItemClick = (item) => {
    dispatch(
      ComposedActions.PushHermesysMenuItem.aCreator({
        menuItemId: item.id,
      })
    );
    setActiveMenu(null);
  };

  return (
    <MenuBar>
      {menuItems.map((menuItem, index) => (
        <div>
          <MenuItems
            key={menuItem.id}
            onClick={(evt) => handleClick(index, menuItem, evt)}
            id={menuItem.id}
          >
            {menuItem.label}
          </MenuItems>
          {menuItem.children && (
            <StyledMenu
              elevation={0}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              getContentAnchorEl={null}
              anchorEl={anchorEl}
              keepMounted
              open={activeMenu === index}
              onClose={handleClose}
            >
              {menuItem.children.map((subMenuItem) => (
                <StyledMenuListItem
                  key={subMenuItem.id}
                  id={subMenuItem.id}
                  onClick={(e) => onMenuItemClick(subMenuItem)}
                >
                  {subMenuItem.label}
                </StyledMenuListItem>
              ))}
            </StyledMenu>
          )}
        </div>
      ))}
    </MenuBar>
  );
};
